// extracted by mini-css-extract-plugin
var _1 = "SplitterElement_blockHidden__f9768";
var _2 = "SplitterElement_cropperLeft__588f0";
var _3 = "SplitterElement_cropperRight__efcf6";
var _4 = "SplitterElement_customIcon__502d7";
var _5 = "SplitterElement_image__e3402";
var _6 = "SplitterElement_img__b982e";
var _7 = "SplitterElement_left__e402d";
var _8 = "SplitterElement_pdf__07fe5";
var _9 = "SplitterElement_right__c60db";
var _a = "SplitterElement_root__16c35";
var _b = "SplitterElement_splitterBody__6a0f0";
var _c = "SplitterElement_text__4ebca";
var _d = "SplitterElement_wrap__584e6";
export { _1 as "blockHidden", _2 as "cropperLeft", _3 as "cropperRight", _4 as "customIcon", _5 as "image", _6 as "img", _7 as "left", _8 as "pdf", _9 as "right", _a as "root", _b as "splitterBody", _c as "text", _d as "wrap" }
